// extracted by mini-css-extract-plugin
export var searchHeader = "_9c-0";
export var searchHeaderDark = "_9c-1";